import React, { useState } from "react";
import {
  Button,
  Container,
  Dropdown,
  Form,
  Nav,
  NavDropdown,
  Navbar,
} from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

// css
import styles from "./Header.module.scss";

// img
import logo from "../../Assets/images/logo.png";
import userImg from "../../Assets/images/dummy_user.jpg";
import ConfirmationPop from "../Modals/ConfirmationPop";
import { useLogoutMutation } from "store/services/auth";
import { useSelector } from "react-redux";
import { userFullName } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { NOTIFICATIONS, PROFILE } from "config/paths";
import { useGetUnreadNotificationsCountQuery } from "store/services/notifications";

const Header = ({ sidebar, setSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state) => state.auth.user);
  const [logout, { isLoading: logoutLoading }] = useLogoutMutation();
  const { data: notificationsCount, isLoading: notificationsCountLoading } = useGetUnreadNotificationsCountQuery(undefined, {
    // The notification socket keeps this cache current after the initial load.
    refetchOnFocus: false,
  });
  const unreadCount = Number(notificationsCount?.count) || 0;
  const unreadCountLabel = unreadCount > 99 ? "99+" : unreadCount;

  const [confirmation, setConfirmation] = useState();

  const pageName = location.pathname;
  let lastSlashIndex = pageName.lastIndexOf("/");
  let heading;
  if (lastSlashIndex !== -1) {
    const afterLastSlash = pageName.substring(lastSlashIndex + 1);
    heading = afterLastSlash;
  }

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const handleConfirmation = () => setConfirmation(!confirmation);

  const handleLogout = async () => {
    try {
      setConfirmation(false);
      await logout();
    } catch (err) {
      console.log("Error logging user out", err);
    }
  };

  // console.log(heading, "headinggggggg");
  return (
    <>
      <ConfirmationPop
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        type={"logout"}
        confirmHandler={handleLogout}
      />
      <header
        className={`${styles.siteHeader}  siteHeader bg-white  sticky-top py-1 w-100 border-bottom`}
        style={{ zIndex: 99, height: "70px" }}
      >
        {
          logoutLoading && <LoadingIndicator />
        }
        <Container fluid={true}>
          <Navbar expand="lg" className="py-0">
            <Button
              onClick={handleSidebar}
              className="d-lg-none border-0 p-0"
              variant="transparent"
              style={{ width: 30 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3.75 10.5C3.55109 10.5 3.36032 10.4209 3.21967 10.2803C3.07902 10.1396 3 9.94887 3 9.74996V3.75146C3 3.55255 3.07902 3.36179 3.21967 3.22113C3.36032 3.08048 3.55109 3.00146 3.75 3.00146H9.75C9.94891 3.00146 10.1397 3.08048 10.2803 3.22113C10.421 3.36179 10.5 3.55255 10.5 3.75146V9.74996C10.5 9.94887 10.421 10.1396 10.2803 10.2803C10.1397 10.4209 9.94891 10.5 9.75 10.5H3.75ZM14.25 10.5C14.0511 10.5 13.8603 10.4209 13.7197 10.2803C13.579 10.1396 13.5 9.94887 13.5 9.74996V3.75146C13.5 3.55255 13.579 3.36179 13.7197 3.22113C13.8603 3.08048 14.0511 3.00146 14.25 3.00146H20.2485C20.4474 3.00146 20.6382 3.08048 20.7788 3.22113C20.9195 3.36179 20.9985 3.55255 20.9985 3.75146V9.74996C20.9985 9.94887 20.9195 10.1396 20.7788 10.2803C20.6382 10.4209 20.4474 10.5 20.2485 10.5H14.25ZM3.75 21C3.55109 21 3.36032 20.9209 3.21967 20.7803C3.07902 20.6396 3 20.4489 3 20.25V14.25C3 14.051 3.07902 13.8603 3.21967 13.7196C3.36032 13.579 3.55109 13.5 3.75 13.5H9.75C9.94891 13.5 10.1397 13.579 10.2803 13.7196C10.421 13.8603 10.5 14.051 10.5 14.25V20.25C10.5 20.4489 10.421 20.6396 10.2803 20.7803C10.1397 20.9209 9.94891 21 9.75 21H3.75ZM14.25 21C14.0511 21 13.8603 20.9209 13.7197 20.7803C13.579 20.6396 13.5 20.4489 13.5 20.25V14.25C13.5 14.051 13.579 13.8603 13.7197 13.7196C13.8603 13.579 14.0511 13.5 14.25 13.5H20.2485C20.4474 13.5 20.6382 13.579 20.7788 13.7196C20.9195 13.8603 20.9985 14.051 20.9985 14.25V20.25C20.9985 20.4489 20.9195 20.6396 20.7788 20.7803C20.6382 20.9209 20.4474 21 20.2485 21H14.25Z"
                  fill="#b46c9f"
                />
              </svg>
            </Button>
            <Navbar.Brand className={`${styles.logo} d-lg-none`} href="#">
              <img src={logo} alt="" className={`img-fluid`} />
            </Navbar.Brand>

            <Navbar.Toggle
              className="border-0 p-0"
              aria-controls="navbarScroll"
            />
            <Navbar.Collapse
              className={` justify-content-end w-100`}
              id="navbarScroll"
            >
              <Nav className=" my-2 my-lg-0 align-items-center justify-content-between w-100 gap-10 flex-wrap">
                <div className="left d-flex align-items-center gap-10 flex-wrap">
                  {/* <Form
                    className={`${styles.searchForm} mx-lg-2 position-relative`}
                  >
                    <div className="iconWithText position-relative">
                      <Form.Control
                        type="search"
                        placeholder="Search"
                        className=""
                        aria-label="Search"
                      />
                      <Button
                        variant="transparent"
                        className="border-0 icn p-0 position-absolute"
                        style={{ left: 10 }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_8_762)">
                            <path
                              d="M17.7916 17.4843L12.6916 12.3843C13.6666 11.1843 14.2666 9.60928 14.2666 7.88428C14.2666 3.98428 11.0416 0.759277 7.1416 0.759277C3.2416 0.759277 0.0166016 3.98428 0.0166016 7.88428C0.0166016 11.7843 3.2416 15.0093 7.1416 15.0093C8.8666 15.0093 10.3666 14.4093 11.6416 13.4343L16.7416 18.5343C16.8916 18.6843 17.1166 18.7593 17.2666 18.7593C17.4166 18.7593 17.6416 18.6843 17.7916 18.5343C18.0916 18.2343 18.0916 17.7843 17.7916 17.4843ZM7.1416 13.5093C4.0666 13.5093 1.5166 10.9593 1.5166 7.88428C1.5166 4.80928 4.0666 2.25928 7.1416 2.25928C10.2166 2.25928 12.7666 4.80928 12.7666 7.88428C12.7666 10.9593 10.2166 13.5093 7.1416 13.5093Z"
                              fill="#1C1B1F"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_8_762">
                              <rect
                                width="18"
                                height="18"
                                fill="white"
                                transform="translate(0.0166016 0.759277)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </Button>
                      <Button
                        variant="transparent"
                        className="border-0 icn p-0 position-absolute"
                        style={{ right: 10 }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                        >
                          <path
                            d="M7.33001 13.593H1.0293"
                            stroke="#c4c4c4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.1406 3.90066H16.4413"
                            stroke="#c4c4c4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.72629 3.84625C5.72629 2.5506 4.66813 1.5 3.36314 1.5C2.05816 1.5 1 2.5506 1 3.84625C1 5.14191 2.05816 6.19251 3.36314 6.19251C4.66813 6.19251 5.72629 5.14191 5.72629 3.84625Z"
                            stroke="#c4c4c4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.0002 13.5533C17.0002 12.2576 15.9429 11.207 14.6379 11.207C13.3321 11.207 12.2739 12.2576 12.2739 13.5533C12.2739 14.8489 13.3321 15.8995 14.6379 15.8995C15.9429 15.8995 17.0002 14.8489 17.0002 13.5533Z"
                            stroke="#c4c4c4"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </Button>
                    </div>
                  </Form> */}
                </div>
                <div className="right d-flex align-items-center gap-10 flex-wrap">
                  <ul className="list-unstyled ps-0 mb-0 gap-10 d-flex align-items-center justify-content-center">
                    {/* <li className="">
                      <Link
                        to={""}
                        className={`${styles.navBtn} text-dark position-relative`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 41 41"
                          fill="none"
                        >
                          <circle
                            cx="20.1906"
                            cy="20.8117"
                            r="20.1906"
                            fill="#F6F6F6"
                          />
                          <g clip-path="url(#clip0_0_4772)">
                            <path
                              d="M11.0132 20.2352C11.1238 18.4456 11.7557 16.7275 12.8309 15.2927C13.9062 13.8579 15.3779 12.7691 17.0645 12.1605C18.751 11.552 20.5789 11.4503 22.3225 11.868C24.0662 12.2857 25.6496 13.2045 26.8774 14.5112C28.1052 15.8179 28.9237 17.4553 29.2322 19.2216C29.5406 20.9879 29.3255 22.8059 28.6132 24.4513C27.9009 26.0968 26.7227 27.4979 25.2238 28.4819C23.7248 29.4658 21.9707 29.9896 20.1777 29.9887H14.8372C13.8233 29.9877 12.8512 29.5845 12.1343 28.8676C11.4174 28.1506 11.0142 27.1786 11.0132 26.1647V20.2352ZM12.5428 26.1647C12.5428 26.7732 12.7845 27.3568 13.2148 27.7871C13.6451 28.2174 14.2286 28.4591 14.8372 28.4591H20.1777C21.2569 28.4586 22.3239 28.2307 23.309 27.7901C24.2942 27.3496 25.1755 26.7064 25.8953 25.9024C26.6187 25.0988 27.1619 24.1498 27.4885 23.1191C27.8151 22.0884 27.9175 20.9998 27.789 19.9263C27.586 18.233 26.8252 16.6554 25.6266 15.4422C24.4279 14.229 22.8596 13.4493 21.1689 13.2259C20.8391 13.1846 20.5071 13.1636 20.1747 13.1632C18.3923 13.1583 16.6652 13.7811 15.296 14.9222C14.4964 15.5868 13.8401 16.4068 13.3668 17.3326C12.8935 18.2583 12.6132 19.2706 12.5428 20.3079V26.1647Z"
                              fill="#071E3E"
                            />
                            <path
                              d="M23.2499 18.5169H20.1907C19.9878 18.5169 19.7933 18.4363 19.6499 18.2929C19.5064 18.1495 19.4259 17.9549 19.4259 17.7521C19.4259 17.5493 19.5064 17.3547 19.6499 17.2113C19.7933 17.0679 19.9878 16.9873 20.1907 16.9873H23.2499C23.4527 16.9873 23.6472 17.0679 23.7906 17.2113C23.9341 17.3547 24.0146 17.5493 24.0146 17.7521C24.0146 17.9549 23.9341 18.1495 23.7906 18.2929C23.6472 18.4363 23.4527 18.5169 23.2499 18.5169Z"
                              fill="#071E3E"
                            />
                            <path
                              d="M17.1315 20.0469H23.2499C23.4527 20.0469 23.6472 20.1275 23.7906 20.2709C23.9341 20.4143 24.0146 20.6088 24.0146 20.8117C24.0146 21.0145 23.9341 21.209 23.7906 21.3525C23.6472 21.4959 23.4527 21.5765 23.2499 21.5765H17.1315C16.9286 21.5765 16.7341 21.4959 16.5907 21.3525C16.4473 21.209 16.3667 21.0145 16.3667 20.8117C16.3667 20.6088 16.4473 20.4143 16.5907 20.2709C16.7341 20.1275 16.9286 20.0469 17.1315 20.0469Z"
                              fill="#071E3E"
                            />
                            <path
                              d="M17.1315 23.1055H23.2499C23.4527 23.1055 23.6472 23.186 23.7906 23.3295C23.9341 23.4729 24.0146 23.6674 24.0146 23.8703C24.0146 24.0731 23.9341 24.2676 23.7906 24.4111C23.6472 24.5545 23.4527 24.6351 23.2499 24.6351H17.1315C16.9286 24.6351 16.7341 24.5545 16.5907 24.4111C16.4473 24.2676 16.3667 24.0731 16.3667 23.8703C16.3667 23.6674 16.4473 23.4729 16.5907 23.3295C16.7341 23.186 16.9286 23.1055 17.1315 23.1055Z"
                              fill="#071E3E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_0_4772">
                              <rect
                                width="18.3551"
                                height="18.3551"
                                fill="white"
                                transform="matrix(-1 0 0 1 29.3682 11.6338)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </Link>
                    </li> */}
                    {/* <li className="">
                      <Dropdown
                        className={`${styles.notificationDropdown} noAfter px-2`}
                      >
                        <div
                          className="position-fixed h-100 w-100 bg-dark d-none"
                          style={{ left: 0, top: 0, opacity: 0.5 }}
                        ></div>
                        <Dropdown.Toggle
                          className={`${styles.navBtn} text-dark border-0 p-0 position-relative`}
                          variant="transparent"
                          id="dropdown-basic"
                        >
                          <span
                            className="count position-absolute p-1 rounded-circle"
                            style={{ background: "#00D957", right: 5, top: 0 }}
                          ></span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="35"
                            height="35"
                            viewBox="0 0 41 41"
                            fill="none"
                          >
                            <circle
                              cx="20.3825"
                              cy="20.8117"
                              r="20.1906"
                              fill="#F6F6F6"
                            />
                            <g clip-path="url(#clip0_0_4768)">
                              <path
                                d="M28.4528 21.6999L27.1129 17.0788C26.6806 15.5898 25.7425 14.2822 24.4474 13.3636C23.1524 12.4451 21.5748 11.9684 19.9652 12.0093C18.3556 12.0501 16.8064 12.6061 15.5637 13.589C14.321 14.5719 13.4561 15.9253 13.1064 17.4342L12.0708 21.9047C11.9342 22.495 11.9374 23.1071 12.0802 23.696C12.223 24.2849 12.5017 24.8355 12.8957 25.3071C13.2898 25.7788 13.7891 26.1595 14.3569 26.4211C14.9247 26.6827 15.5465 26.8186 16.1763 26.8187H16.4822C16.7256 27.6268 17.2359 28.337 17.9362 28.8424C18.6365 29.3478 19.4889 29.6211 20.3651 29.6211C21.2412 29.6211 22.0936 29.3478 22.794 28.8424C23.4943 28.337 24.0045 27.6268 24.2479 26.8187H24.3955C25.044 26.8188 25.6838 26.675 26.2647 26.3984C26.8457 26.1218 27.3522 25.72 27.7447 25.2244C28.1371 24.7288 28.4049 24.1528 28.5271 23.5414C28.6493 22.93 28.6225 22.2997 28.449 21.6999H28.4528ZM25.9221 23.8907C25.7445 24.117 25.5144 24.3004 25.2501 24.4264C24.9858 24.5523 24.6945 24.6173 24.3994 24.6161H16.1763C15.89 24.6161 15.6074 24.5543 15.3494 24.4354C15.0913 24.3165 14.8643 24.1435 14.6852 23.9291C14.5061 23.7147 14.3794 23.4645 14.3145 23.1968C14.2496 22.9292 14.2481 22.651 14.3102 22.3827L15.3457 17.904C15.5835 16.8733 16.1736 15.9485 17.0222 15.2769C17.8707 14.6053 18.9289 14.2255 20.0283 14.198C21.1276 14.1705 22.205 14.4968 23.0888 15.125C23.9727 15.7532 24.6122 16.6472 24.9057 17.6647L26.2425 22.2858C26.3232 22.5588 26.3362 22.8461 26.2806 23.1247C26.2249 23.4034 26.1022 23.6657 25.9221 23.8907Z"
                                fill="#071E3E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_0_4768">
                                <rect
                                  width="18.3551"
                                  height="17.6209"
                                  fill="white"
                                  transform="translate(11.2051 12.001)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className={`${styles.menu}  pt-0 shadow-sm border-0`}
                        >
                          <div
                            className={`${styles.top} top py-3 px-3 d-flex justify-content-between align-items-center mb-2`}
                          >
                            <h4 className="m-0 fw-sbold">
                              Notifications{" "}
                              <span
                                className={`${styles.count} text-white rounded-circle fw-normal d-inline-flex align-items-center justify-content-center`}
                              >
                                2
                              </span>
                            </h4>
                            <Button
                              className="border-0 p-0"
                              variant="transparent"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="4"
                                height="19"
                                viewBox="0 0 4 19"
                                fill="none"
                              >
                                <circle
                                  cx="1.64589"
                                  cy="1.59413"
                                  r="1.55019"
                                  fill="#80849D"
                                />
                                <circle
                                  cx="1.64589"
                                  cy="9.03456"
                                  r="1.55019"
                                  fill="#80849D"
                                />
                                <circle
                                  cx="1.64589"
                                  cy="16.476"
                                  r="1.55019"
                                  fill="#80849D"
                                />
                              </svg>
                            </Button>
                          </div>
                          <div className="ContentBody">
                            <ul
                              className={`${styles.notificationList} list-unstyled ps-0 mb-0`}
                            >
                              <li className="py-3 d-flex align-items-start gap-10 px-3">
                                <div
                                  className="imgWrp rounded-circle flex-shrink-0"
                                  style={{
                                    height: 40,
                                    width: 40,
                                    background: "#6CBC6E",
                                  }}
                                >
                                  <img
                                    src={userImg}
                                    alt=""
                                    className="img-fluid h-100 w-100 rounded-circle"
                                    style={{ objectFit: "cover" }}
                                  />
                                </div>
                                <div className="content">
                                  <h6 className="fw-bold text-dark m-0">
                                    Edward Curr
                                  </h6>
                                  <p
                                    className=" text-dark m-0 forteen"
                                    style={{ lineHeight: "20px" }}
                                  >
                                    agency driver submits their profile for
                                    verification
                                  </p>
                                  <div className="btnWrpper my-2 d-flex align-items-center gap-10">
                                    <Button className="d-flex align-items-center justify-content-center h-auto commonBtn">
                                      Approve
                                    </Button>
                                    <Button
                                      className="d-flex align-items-center justify-content-center h-auto commonBtn bg-transparent text-muted broder-light"
                                      style={{ borderColor: "#ddd" }}
                                    >
                                      Reject
                                    </Button>
                                  </div>
                                  <p className="m-0 text-muted">17 min ago</p>
                                </div>
                              </li>
                              <li className="py-3 d-flex align-items-start gap-10 px-3">
                                <div
                                  className="imgWrp rounded-circle flex-shrink-0"
                                  style={{
                                    height: 40,
                                    width: 40,
                                    background: "#6CBC6E",
                                  }}
                                >
                                  <img
                                    src={userImg}
                                    alt=""
                                    className="img-fluid h-100 w-100 rounded-circle"
                                    style={{ objectFit: "cover" }}
                                  />
                                </div>
                                <div className="content">
                                  <h6 className="fw-bold text-dark m-0">
                                    Edward Curr
                                  </h6>
                                  <p
                                    className=" text-dark m-0"
                                    style={{ lineHeight: "20px" }}
                                  >
                                    agency driver submits their profile for
                                    verification agency driver submits their
                                    profile for verification agency driver
                                    submits their profile for verification
                                  </p>
                                  <p className="m-0 text-muted">17 min ago</p>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li> */}
                    <li className="">
                      <Button
                        onClick={() => navigate(NOTIFICATIONS)}
                        className={`${styles.navBtn} ${styles.notificationButton} text-dark border-0 p-0 position-relative`}
                        variant="transparent"
                        aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"}
                      >
                        {!notificationsCountLoading && unreadCount > 0 && (
                          <span className={styles.notificationCount} aria-hidden="true">
                            {unreadCountLabel}
                          </span>
                        )}
                       <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="35"
                            height="35"
                            viewBox="0 0 41 41"
                            fill="none"
                          >
                            <circle
                              cx="20.3825"
                              cy="20.8117"
                              r="20.1906"
                              fill="#F6F6F6"
                            />
                            <g clip-path="url(#clip0_0_4768)">
                              <path
                                d="M28.4528 21.6999L27.1129 17.0788C26.6806 15.5898 25.7425 14.2822 24.4474 13.3636C23.1524 12.4451 21.5748 11.9684 19.9652 12.0093C18.3556 12.0501 16.8064 12.6061 15.5637 13.589C14.321 14.5719 13.4561 15.9253 13.1064 17.4342L12.0708 21.9047C11.9342 22.495 11.9374 23.1071 12.0802 23.696C12.223 24.2849 12.5017 24.8355 12.8957 25.3071C13.2898 25.7788 13.7891 26.1595 14.3569 26.4211C14.9247 26.6827 15.5465 26.8186 16.1763 26.8187H16.4822C16.7256 27.6268 17.2359 28.337 17.9362 28.8424C18.6365 29.3478 19.4889 29.6211 20.3651 29.6211C21.2412 29.6211 22.0936 29.3478 22.794 28.8424C23.4943 28.337 24.0045 27.6268 24.2479 26.8187H24.3955C25.044 26.8188 25.6838 26.675 26.2647 26.3984C26.8457 26.1218 27.3522 25.72 27.7447 25.2244C28.1371 24.7288 28.4049 24.1528 28.5271 23.5414C28.6493 22.93 28.6225 22.2997 28.449 21.6999H28.4528ZM25.9221 23.8907C25.7445 24.117 25.5144 24.3004 25.2501 24.4264C24.9858 24.5523 24.6945 24.6173 24.3994 24.6161H16.1763C15.89 24.6161 15.6074 24.5543 15.3494 24.4354C15.0913 24.3165 14.8643 24.1435 14.6852 23.9291C14.5061 23.7147 14.3794 23.4645 14.3145 23.1968C14.2496 22.9292 14.2481 22.651 14.3102 22.3827L15.3457 17.904C15.5835 16.8733 16.1736 15.9485 17.0222 15.2769C17.8707 14.6053 18.9289 14.2255 20.0283 14.198C21.1276 14.1705 22.205 14.4968 23.0888 15.125C23.9727 15.7532 24.6122 16.6472 24.9057 17.6647L26.2425 22.2858C26.3232 22.5588 26.3362 22.8461 26.2806 23.1247C26.2249 23.4034 26.1022 23.6657 25.9221 23.8907Z"
                                fill="#071E3E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_0_4768">
                                <rect
                                  width="18.3551"
                                  height="17.6209"
                                  fill="white"
                                  transform="translate(11.2051 12.001)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                      </Button>
                    </li>
                  </ul>
                  <Dropdown>
                    <Dropdown.Toggle
                      className={`${styles.profileLink} ps-3 border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                      variant="transparent"
                      id="dropdown-basic"
                    >
                      <img
                        src={userInfo?.profile_picture || userImg}
                        style={{ aspectRatio: 1, height: 40, width: 40 }}
                        alt=""
                        className="img-fluid rounded-circle object-fit-cover flex-shrink-0"
                      />
                      <div className="content ps-2">
                        <p className="m-0 fw-bold">{userFullName(userInfo)}</p>
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => navigate(PROFILE)}>Profile</Dropdown.Item>
                      <Dropdown.Item onClick={() => setConfirmation(true)}>
                        <Link className="text-danger">
                          Logout
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </header>
    </>
  );
};

export default Header;
